import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Holding } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getHoldings = createAsyncThunk<
  Holding[],
  string,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_HOLDINGS, async (businessDate, { extra }) => {
  return await extra.batchesRepo.getHoldings(businessDate);
});
